import FutureAppointments from "../../applicationUi/components/FutureAppointments";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedAppointment, clearClientAppointments } from "../../store/slices/appointmentsSlice";
import { fetchAppointmentsByClientId } from "../../store/thunks/appointmentsThunk";
import { useState, useEffect } from "react";

const ClientAppointments = ({ onAppointmentClick }) => {
  const dispatch = useDispatch();
  const clientAppointments = useSelector((state) => state.appointments.clientAppointments);
  const client = useSelector((state) => state.clients.selectedClient);
  const loading = useSelector((state) => state.appointments.loading);

  useEffect(() => {
    if (client?._id) {
      dispatch(clearClientAppointments());
      dispatch(fetchAppointmentsByClientId(client._id));
    }
  }, [dispatch, client]);

  const handleAppointmentClick = (appointment) => {
    console.log('[Client Appointments] Appointment clicked:', appointment);
    // Set the appointment in Redux for data access
    dispatch(setSelectedAppointment(appointment));
    // Notify parent to open the wide side panel (this will close the modal first)
    if (onAppointmentClick) {
      onAppointmentClick(appointment);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span className="ml-2 text-gray-600">Loading appointments...</span>
      </div>
    );
  }

  return (
    <div data-component="ClientAppointments">
      {/* Future Appointments Component */}
      <FutureAppointments
        appointments={clientAppointments}
        onAppointmentClick={handleAppointmentClick}
      />
    </div>
  );
};

export default ClientAppointments;
